<template>
	<div class="customSteps">
		<a-collapse default-active-key="1" :bordered="false">
			<a-collapse-panel header="流程记录" key="1">
				<div class="stepsFrames" v-for="(item,index) in recordList" :key="index">
					<div class="time">{{item.operatingTime.substr(0,16)}}</div>
					<div class="line">
						<i :style="{background:item.approvalState=='pass'?'#1DA57A':'#DA4631'}"></i>
						<b v-if="index != recordList.length-1" :style="{background:item.approvalState=='pass'?'#1DA57A':'#DA4631'}"></b>
					</div>
					<div class="text">
						<div>{{item.stepName}}</div>
						<div>{{item.userName}}</div>
						<div>{{item.approvalComment}}</div>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
	</div>
</template>

<script>
	export default {
		props:{
		    businessType: String,
			uuid: String,
		},
		data() {
			return {
				recordList: []
			}
		},
		watch: {
			uuid: {
				immediate: true,
				handler(newVal, oldVal) {
					this.recordList = [];
					if(newVal){
						this.uuid = newVal;
						this.init();
					}
				},
			},
		},
		methods: {
			init() {
				this.$get(`flowUserRecord/listByBusinessTypeAndUuId/${this.businessType}/${this.uuid}`).then(res => {
					this.recordList = res.data;
				});
			},
		},
	}
</script>
<style lang="less" scoped>
	.customSteps{
		.stepsFrames{
			display:flex;
			margin-bottom:3px;
			.time{
				color: #AFAFAF;
				font-size: 12px;
				position: relative;
				top:3px;
				width: 15%;
			}
			.line{
				width: 10%;
				position:relative;
				padding:0 15px;
				i{
					display: inline-block;
					width: 11px;
					height:11px;
					border-radius: 50%;
				}
				b{
					display: inline-block;
					width: 1px;
					height:calc(100% + 3px);
					background: #1DA57A;
					position: absolute;
					top:6px;
					left: 20px;
				}
			}
			.text{
				width:69%;
				div:nth-child(1){
					color: #595959;
					font-size: 15px;
				}
				div:nth-child(2){
					color: #8C8C8C;
					font-size: 14px;
				}
				div:nth-child(3){
					color: #8C8C8C;
					font-size: 13px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/OA/qualityContent/userTaskRecord.vue